// checkProtocolWithIframe(uri, timeoutMs) -> Promise<boolean>
function checkProtocolWithIframe(uri, timeoutMs = 1500) {
  return new Promise((resolve) => {
    let iframe = document.createElement("iframe");
    iframe.style.display = "none";
    let handled = false;
    const onVisibility = () => {
      // Se a página fica oculta, provavelmente o app foi aberto
      if (document.hidden) {
        handled = true;
        cleanup();
        resolve(true);
      }
    };
    const onBlur = () => {
      // Perda de foco pode indicar que o app foi aberto
      handled = true;
      cleanup();
      resolve(true);
    };
    const timer = setTimeout(() => {
      if (!handled) {
        cleanup();
        resolve(false); // provável que não exista handler
      }
    }, timeoutMs);

    function cleanup() {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("blur", onBlur);
      if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
      iframe = null;
    }

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("blur", onBlur);

    document.body.appendChild(iframe);
    try {
      // Navega o iframe para o URI customizado
      iframe.src = uri;
    } catch (e) {
      // atribuicao pode lançar em alguns browsers; tratamos como não disponível
      cleanup();
      resolve(false);
    }
  });
}

export default checkProtocolWithIframe;